export const RESET_FLASH_MSGS = "RESET_FLASH_MSGS";
export const RESET_FLASH_MSG = "RESET_FLASH_MSG";
export const RESET_ERROR = "FLASH_MSGS_RESET_ERROR";

export const GET_FLASH_MSGS = "GET_FLASH_MSGS";
export const SET_FLASH_MSGS = "SET_FLASH_MSGS";

export const API_ERROR = "FLASH_MSGS_API_ERROR";

export const GET_FLASH_MSG = "GET_FLASH_MSG";
export const SET_FLASH_MSG = "SET_FLASH_MSG";

export const EDIT_FLASH_MSG = "EDIT_FLASH_MSG";
export const EDIT_FLASH_MSG_SUCCESS = "EDIT_FLASH_MSG_SUCCESS";

export const CREATE_FLASH_MSG = "CREATE_FLASH_MSG";
export const CREATE_FLASH_MSG_SUCCESS = "CREATE_FLASH_MSG_SUCCESS";

export const DELETE_FLASH_MSG = "DELETE_FLASH_MSG";
export const DELETE_FLASH_MSG_SUCCESS = "DELETE_FLASH_MSG_SUCCESS";
